import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export const fileUrl = (
  id: string | null | undefined,
  variant: 'thumb' | 'display' | 'original' = 'display',
) => (id ? `/api/v1/files/${id}?variant=${variant}` : '');

/** Đường dẫn thuộc module ứng dụng riêng (sub-app) phục vụ bởi Nginx, không thuộc router của SPA này. */
export const isSubAppPath = (path: string) => /^\/(thi-cong|thiet-ke|mo-phong)(\/|$|\?)/.test(path);
